module.exports = __webpack_public_path__ + "img/emptycan-state.e2a3f66a.svg";